const Action ={
accept_img : "./Images/Action/Accept_img.png",
reject_img : "./Images/Action/Reject_img.png",
error_img  :"./Images/Action/error_img.png"
}
export default Action;